import { components, paths } from "@api/api";
import useAxios from "@hooks/useFetch";

const AMONG_COPY_TABLE_ENDPOINT: keyof paths = "/api/CopyTable/GetAmong";

export type AmongCopyTableTextRequest = components["schemas"]["FlavorTracker.Entities.DTO.Common.AmongDropDownBaseRequest"];

export const useAmongCopyTableText = (payload: AmongCopyTableTextRequest) => {
	return useAxios<string, AmongCopyTableTextRequest>({
		url: AMONG_COPY_TABLE_ENDPOINT,
		payload,
		method: 'post',
	});
}